export function refresh(views, userData, loggedIn) {
  if (userData.packages) {
    for (let i = 0; i < views.length; i += 1) {
      views[i].setLoginStatus(loggedIn, userData.packages).updateView(userData);
    }
  }
}
